import { useState } from "react";
import { GlobalStyles, Box, Paper } from "@mui/material";
import { ClearChatHistoryDialog } from "./clear-chat-history-dialog";
import { ChatActions } from "./chat-actions";
import { REQUEST_STATUS } from "../../../shared/consts";
import { useChatContext } from "../chat-context";
import { InfoDialog } from "../../about";
import { SettingsDialog } from "../../settings";
import { SuggestionsList } from "../../word-suggestion";
import { WordSuggestionDialog } from "../../word-suggestion";
import ChatTextInput from "./chat-text-input";

type ChatInputProps = {
  isEmbedded: boolean;
};

export const ChatInput = ({ isEmbedded }: ChatInputProps) => {
  const { requestStatus, requestReportStatus, clearChat } = useChatContext();
  const isLoading =
    requestStatus === REQUEST_STATUS.LOADING ||
    requestReportStatus === REQUEST_STATUS.LOADING;
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);
  const [clearChatDialogOpen, setClearChatDialogOpen] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [suggestionsDialogOpen, setSuggestionsDialogOpen] = useState(false);
  const handleClearChatDialogOpen = () => {
    setClearChatDialogOpen(true);
  };
  const handleClearChatDialogClose = () => {
    setClearChatDialogOpen(false);
  };
  const handleClearChat = () => {
    clearChat();
    handleClearChatDialogClose();
  };
  const paperStyleEmbedded = {
    display: "flex",
    alignItems: "center",
    padding: 2,
  };

  const paperStyle = {
    p: 2,
    position: "fixed",
    bottom: 0,
    left: "10%",
    right: "10%",
    zIndex: 10,
  };
  return (
    <Paper elevation={3} sx={isEmbedded ? paperStyleEmbedded : paperStyle}>
      <GlobalStyles
        styles={{
          body: { paddingRight: "0 !important", overflow: "unset !important" },
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          background: "#fff",
          alignItems: "left",
        }}
      >
        <SuggestionsList onShowAll={() => setSuggestionsDialogOpen(true)} />
        <Box
          sx={{
            display: "flex",
            padding: "10px",
            background: "#fff",
            alignItems: "center",
          }}
        >
          <ChatTextInput isLoading={isLoading} />
          <ChatActions
            handleClearChatDialogOpen={handleClearChatDialogOpen}
            handleSettingsDialogOpen={() => setSettingsDialogOpen(true)}
            handleInfoDialogOpen={() => setInfoDialogOpen(true)}
            handleSuggestionsDialogOpen={() => setSuggestionsDialogOpen(true)}
            isLoading={isLoading}
          />
        </Box>
      </Box>
      <ClearChatHistoryDialog
        dialogOpen={clearChatDialogOpen}
        handleDialogClose={handleClearChatDialogClose}
        handleClearChat={handleClearChat}
      />
      <SettingsDialog
        open={settingsDialogOpen}
        setClose={() => setSettingsDialogOpen(false)}
      />
      <InfoDialog
        open={infoDialogOpen}
        setClose={() => setInfoDialogOpen(false)}
      />
      <WordSuggestionDialog
        open={suggestionsDialogOpen}
        setClose={() => setSuggestionsDialogOpen(false)}
      />
    </Paper>
  );
};
